// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"176164c6","644":"4f137d7e","667":"97be941e"}[chunkId] + ".chunk.js";
};